import { render } from "./QuickLink.vue?vue&type=template&id=9e31809c&scoped=true"
import script from "./QuickLink.vue?vue&type=script&lang=js"
export * from "./QuickLink.vue?vue&type=script&lang=js"

import "./QuickLink.vue?vue&type=style&index=0&id=9e31809c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e31809c"]])

export default __exports__